import { render } from "./CourseCOMP.vue?vue&type=template&id=1f2345f4&scoped=true"
import script from "./CourseCOMP.vue?vue&type=script&lang=js"
export * from "./CourseCOMP.vue?vue&type=script&lang=js"

import "./CourseCOMP.vue?vue&type=style&index=0&id=1f2345f4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2345f4"]])

export default __exports__